import { useSelector } from 'react-redux';
import { getComplexId, getCurrentLang } from 'src/store/app/selectors';
import { useGetComplex } from 'src/hooks/useGetComplex';
import { useCallback } from 'react';
import { IPlacementProperty } from 'src/typings/viewConfig';
import { ListOfKeysFilterAllData } from 'src/typings/filter';

export const useComplex = (safeToStore: boolean = false) => {
  const complexId = useSelector(getComplexId);
  const currentLang = useSelector(getCurrentLang);
  const { complex } = useGetComplex(complexId ? String(complexId) : null, safeToStore);
  const getComplexTranslation = useCallback((name: ListOfKeysFilterAllData): string => {
    if (complex) {
      const combinedProperties = [...complex.applicationProperties, ...complex.placementProperties];
      const foundProp = combinedProperties.find((prop) => (prop as IPlacementProperty)?.oldSystemName === name || prop?.systemName === name);
      return foundProp?.translates?.[currentLang] || name;
    }
    return name;
  }, [complex, currentLang]);
  return {
    complexId,
    complex,
    getComplexTranslation,
  };
};
